// extracted by mini-css-extract-plugin
export var root = "dr6-";
export var rootBody = "c4bu";
export var rootIcon = "+O5g";
export var rootIconWrapper = "tXlQ";
export var rootInput = "RkSD";
export var rootLabel = "kt4a";